"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowsFixClientId = allowsFixClientId;
exports.default = void 0;
exports.displayThirdInputCopyText = displayThirdInputCopyText;
exports.needsFixClientId = needsFixClientId;
exports.needsFixCompId = needsFixCompId;
exports.needsThirdInput = needsThirdInput;
var _IntegrationType = _interopRequireDefault(require("../enums/IntegrationType"));
function displayThirdInputCopyText(type) {
  if (type === _IntegrationType.default.EXCHANGE_GDAX || type === _IntegrationType.default.EXCHANGE_OKCOIN || type === _IntegrationType.default.EXCHANGE_OKEX || type === _IntegrationType.default.EXCHANGE_SEEDCX) {
    return 'passphrase';
  }
  if (type === _IntegrationType.default.EXCHANGE_BITSTAMP || type === _IntegrationType.default.EXCHANGE_ITBIT) {
    return 'userId';
  }
  return 'password';
}

function needsFixClientId(type) {

  return false;
}

function allowsFixClientId(type) {
  return type === _IntegrationType.default.EXCHANGE_FTX;
}

function needsFixCompId(type) {
  return type === _IntegrationType.default.EXCHANGE_GEMINI
  ;
}

function needsThirdInput(type) {
  return type === _IntegrationType.default.EXCHANGE_BITSTAMP || type === _IntegrationType.default.EXCHANGE_GDAX || type === _IntegrationType.default.EXCHANGE_ITBIT ||
  type === _IntegrationType.default.EXCHANGE_KUCOIN || type === _IntegrationType.default.EXCHANGE_LMAX || type === _IntegrationType.default.EXCHANGE_OKCOIN || type === _IntegrationType.default.EXCHANGE_OKEX || type === _IntegrationType.default.EXCHANGE_SEEDCX;
}
var _default = {
  displayThirdInputCopyText,
  needsFixClientId,
  needsFixCompId,
  needsThirdInput
};
exports.default = _default;